/**
 * Class types enum matching Laravel API's ClassTypesEnum
 * These values must match the backend enum: App\Enums\ClassTypesEnum
 */
export enum ClassTypes {
  ANGLE = 'angle',
  ANGLES = 'angles',
  CONCEPT = 'concept',
  CONCEPTS = 'concepts',
  CONCEPT_ANGLE = 'concept_angle',
  CONCEPT_ANGLES = 'concept_angles',
  CONTROL = 'control',
  FILE = 'file',
  FILES = 'files',
  MATERIAL = 'material',
  PALETTE = 'palette',
  STYLE = 'style',
  USER = 'user',
  USERS = 'users',
  PROMPT = 'prompt',
  PROMPTS = 'prompts',
  PROMO_CODE = 'promo_code',
  PROJECT = 'project',
  PROJECTS = 'projects',
  REFERENCE = 'reference',
  REFERENCES = 'references',
  RENDER = 'render',
  RENDERS = 'renders',
  SUBSCRIPTION = 'subscription',
  PLAN = 'plan',
  PAYMENT = 'payment',
  PAYMENT_METHOD = 'payment-methods',
  PAYMENT_CONFIRMATION = 'payment-confirmations',
  USER_PROFILE = 'user_profile',
  CHECKOUT_SESSION = 'checkout_session',
  TOKEN_BALANCE = 'token_balance',
  TOKEN_CHECKOUT = 'token_checkout',
  USAGE_STATS = 'usage-stats',
  USAGE = 'usage',
  PAYMENT_GATEWAY = 'payment-gateways',
  TOKEN_PACKAGE = 'token_package',
}

/**
 * Type for upload types used in image upload services
 */
export type UploadType = 'angle' | 'reference' | 'control';

/**
 * Type for image types used in various UI components
 */
export type ImageType = 'render' | 'angle';

/**
 * Type for reference types used in concept references
 */
export type ReferenceType = 'user' | 'system';
